export default "__VITE_ASSET__DdEj0b35__"